import Icon from "@ant-design/icons"
import { ReactComponent as SaudiFlag } from "./saudi.svg"

const SaudiFlagIcon = (props: any) => <Icon component={SaudiFlag} {...props} />

export default SaudiFlagIcon
